import React, { Suspense } from 'react';
import SocialFeedLoadingState from './SocialFeedLoadingState';

const SocialFeed = React.lazy(() => import(/* webpackChunkName: "SocialFeed" */ './SocialFeed'));

const CuratorIOSocialFeedProvider = React.lazy(() => import(/* webpackChunkName: "SocialFeed" */ './data/CuratorIOSocialFeedProvider'));
export default class SocialFeedLoader {
    constructor(config) {
        this.config = this._parseConfiguration(config);
    }

    getComponent() {
        const component = <SocialFeed {...this.config} />;
        const dataProvider = this._getDataProvider(component);

        return <Suspense fallback={<SocialFeedLoadingState {...this.config} />}>{dataProvider}</Suspense>;
    }

    _parseConfiguration(config) {
        return {
            ...config,
        };
    }

    _getDataProvider(component) {
        const { datasource, datasourceUrl, datasourceApiKey, curatorFeed } = this.config;

        if (datasource === 'curator') {
            return (
                <CuratorIOSocialFeedProvider curatorUrl={datasourceUrl} apiKey={datasourceApiKey} feedId={curatorFeed}>
                    {component}
                </CuratorIOSocialFeedProvider>
            );
        }

        return component;
    }
}
